let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("764nc")).then(() => parcelRequire('SMbnh'));